<template>
	<div>

		<div class="row section-top">
			<div class="col-md-12 pad0">
				<p class="section-lead">Lista de todas Atividades da Governança</p>
        <a
          class="btn btn-outline-warning float-right"
          data-toggle="collapse"
          href="#panelFilter"
          role="button"
          aria-expanded="false"
          aria-controls="panelFilter"
          ><i class="fas fa-filter"></i>&nbsp;Filtrar</a
        >
			</div>
		</div>

		<!-- filter -->
		<div class="row">
			<div class="col-md-12">
        <div class="collapse" id="panelFilter">
          <div class="card card-body">
            <div class="row">

              <!-- company id -->
              <div class="col-md-6 mt-2">
                <div class="form-group">
                  <label class="form-control-label" for="input-work_place_id">Empresa</label>
                  <v-select :options="filterCompanies" label="corporate_name" v-bind:class="{'is-invalid': errors.company}" :reduce="corporate_name => corporate_name.id" v-model="filterItems.company_id" @input="validateCompany('filter')" :disabled="true"></v-select>
                  <div class="invalid-feedback d-block" v-if="errors.company" >
                    <p>{{ errors.company[0] }}</p>
                  </div>
                </div>
              </div>

              <!-- contract -->
              <div class="col-md-6 mt-2">
                <div class="form-group">
                  <label class="form-control-label" for="input-work_place_id">Contrato</label>
                  <v-select :options="filterContracts" label="corporate_name" v-bind:class="{'is-invalid': errors.contract}" :reduce="corporate_name => corporate_name.id" v-model="filterItems.contract_id" :disabled="true"></v-select>
                  <div class="invalid-feedback d-block" v-if="errors.contract" >
                    <p>{{ errors.contract[0] }}</p>
                  </div>
                </div>
              </div>

              <!-- work_place_id -->
              <div class="col-md-6 mt-2">
                <div class="form-group">
                  <label class="form-control-label" for="input-work_place_id">Local de Trabalho</label>
                  <v-select :options="filterWorkplaces" label="corporate_name" v-bind:class="{'is-invalid': errors.workplace}" :reduce="corporate_name => corporate_name.id" v-model="filterItems.work_place_id" @input="validateWorkplace('filter')"></v-select>
                  <div class="invalid-feedback d-block" v-if="errors.workplace" >
                    <p>{{ errors.workplace[0] }}</p>
                  </div>
                </div>
              </div>

              <!-- sublocal -->
              <div class="col-md-6 mt-2">
                <div class="form-group">
                  <label class="form-control-label" for="input-sublocal">Sublocal</label>
                  <v-select :options="filterSublocal" label="corporate_name" v-bind:class="{'is-invalid': errors.sublocal}" :reduce="corporate_name => corporate_name.id" v-model="filterItems.sublocal_id" @input="validateSublocal('filter')"></v-select>
                  <div class="invalid-feedback d-block" v-if="errors.sublocal" >
                    <p>{{ errors.sublocal[0] }}</p>
                  </div>
                </div>
              </div>

              <!-- sector_id -->
              <div class="col-md-6 mt-2">
                <div class="form-group">
                  <label class="form-control-label" for="input-sector_id">Setor</label>
                  <v-select :options="filterSectors" label="name" v-bind:class="{'is-invalid': errors.sector_id}" :reduce="name => name.id" v-model="filterItems.sector_id" multiple></v-select>
                  <div class="invalid-feedback d-block" v-if="errors.sector_id">
                    <p>{{ errors.sector_id[0] }}</p>
                  </div>
                </div>
              </div>
              
              <!-- subsector_id -->
              <div class="col-md-6 mt-2">
                <div class="form-group">
                  <label class="form-control-label" for="input-subsector_id">Subsetor</label>
                  <v-select :options="filterSubsectors" v-bind:class="{'is-invalid': errors.subsector_id}" :reduce="name => name.id" label="name" v-model="filterItems.subsector_id" multiple></v-select>
                  <div class="invalid-feedback d-block" v-if="errors.subsector_id">
                    <p>{{ errors.subsector_id[0] }}</p>
                  </div>
                </div>
              </div>

              <div class="col-md-12 mt-2 text-right">
                <a class="btn btn-outline-secondary" style="margin-right: 20px;" @click="clearFilter()">LIMPAR</a>
                <button class="btn btn-success" @click="loadActivities()">FILTRAR</button>
              </div>

            </div>
          </div>
        </div>
			</div>
		</div>
		<!-- end filter -->

		<div class="row">
			<div class="col">

        <div class="row" v-if="subsectorsItems.length > 0">
          <div class="col-md-2 item-activity" v-for="(item, index) in subsectorsItems" :key="index" @click="viewActivities(item)">
            <div class="card" style="height: 140px;">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-12 text-center" style="height: 80px;">
                    <h4 style="font-size: 16px;">{{ item.subsector_name }}</h4>
                    <h5 style="font-size: 12px;font-weight:300;">{{ item.sublocal_name }}</h5>
                  </div>
                  <div class="col-md-6 text-center" :class="validateStatus(item.activities,'activities')">
                    <i class="far fa-check-square"></i>
                    {{ item.activities.length }}
                  </div>
                  <div class="col-md-6 text-center" :class="validateStatus(item.occurrences,'occurrences')">
                    <i class="fas fa-exclamation-triangle"></i>
                    {{ item.occurrences.length }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="text-center p-3 text-muted" style="margin-top: 20px">
          <h5>Nenhuma atividade encontrada!</h5>
        </div>

				<div class="text-center p-4 text-muted" v-if="loading">
					<h5>Carregando...</h5>
					<p>Aguarde até que os dados sejam carregados...</p>
				</div>

			</div>

			<!-- modal -->
			<div class="modal fade" id="modalActivities" tabindex="-1" aria-labelledby="modalActivitiesLabel" aria-hidden="true">
				<div class="modal-dialog modal-dialog-centered modal-lg">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title" id="modalActivitiesLabel">Atividades e Ocorrências</h5>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body">
							<div class="row">
								<div class="col-md-12">
									<!-- Filtro estilo tabs moderno -->
									<div class="custom-tabs mb-4">
										<button class="custom-tab" :class="selectedModal.active == 'all' ? 'active' : ''" @click="filterActivities('all')">
											Todas <span class="badge">{{ selectedModal.total.length }}</span>
										</button>
										<button class="custom-tab" :class="selectedModal.active == 'activities' ? 'active' : ''" @click="filterActivities('activities')">
											Atividades <span class="badge">{{ selectedModal.activities.length }}</span>
										</button>
										<button class="custom-tab" :class="selectedModal.active == 'occurrences' ? 'active' : ''" @click="filterActivities('occurrences')">
											Ocorrências <span class="badge">{{ selectedModal.occurrences.length }}</span>
										</button>
									</div>

									<!-- Tabela de resultados -->
									<div class="table-container">
										<table class="table table-bordered table-striped bg-white">
											<thead>
												<tr>
													<th class="col-7">Título</th>
													<th class="col-3">Status</th>
													<th class="col-2">Ações</th>
												</tr>
											</thead>
											<tbody id="resultadoTabela">
												<tr v-for="(item, index) in selectedModal.showing" :key="index">
													<td>{{ item.title }}</td>
													<td>{{ item.activity_status_name }}</td>
													<td>
														<button class="btn btn-outline-secondary btn-sm" @click="goToActivity(item)">
															<i class="far fa-eye"></i>
														</button>
													</td>
												</tr>
												<tr v-if="selectedModal.showing.length == 0">
													<td colspan="3" class="text-center">Nenhum resultado encontrado!</td>
												</tr>
												<tr v-if="selectedModal.showing.length > 0">
													<td colspan="3" class="text-center">Total de {{ selectedModal.showing.length }} registros</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<vue-loading color="#212121" :active.sync="loading" :can-cancel="false" :is-full-page="fullPage"></vue-loading>
		</div>
	</div>
</template>

<script>
	import ApiService from '../../apiservice.js';
	import ExportGrid from '../../exportgrid.js';
	export default {
		mixins: [ApiService, ExportGrid],
		data() {
			return {
        subsectorsItems: [],
				filterCompanies: [],
				filterListItems: [],
				filterWorkplaces: [],
				filterSublocal: [],
				filterContracts: [],
				filterSectors: [],
				filterSubsectors: [],
        filterItems: {
          company_id: 3,
          contract_id: 3,
          work_place_id: null,
          sublocal_id: null,
          sector_id: null,
          subsector_id: null,
          status: null
        },
				selectedModal: {
					active: 'all',
					showing: [],
					total: [],
					activities: [],
					occurrences: []
				},
				fullPage: true,
				errors: [],
				loading: false,
				userCan: ''
			}
		},
		mounted() {
			this.loadCompanies();
      this.loadActivities();
		},
		methods: {
			loadActivities(){
				let _this = this;
				_this.loading = true;
				_this.subsectorsItems = [];

				let dataFilter = {
					"company_id" : _this.filterItems.company_id,
					"contract_id" : _this.filterItems.contract_id,
					"workplace_id" : _this.filterItems.work_place_id,
					"sublocal_id" : _this.filterItems.sublocal_id,
					"sector_id" : _this.filterItems.sector_id,
					"subsector_id" : _this.filterItems.subsector_id
				};

				axios.post("/admin/governance/filter", dataFilter).then((res) => {
					_this.subsectorsItems = _this.subsectorsItems.concat(res.data.data);
					_this.loading = false;
				}).catch((err) => {
					_this.loading = false;
				});
			},
      loadCompanies() {
				let _this = this;
				axios.get("/admin/companies").then((res) => {
					res.data.sort(function(a, b){
						return a.corporate_name - b.corporate_name;
					});
					_this.filterCompanies = _this.filterCompanies.concat(res.data);
          _this.validateCompany('filter');
				}).catch((err) => {
				});
			},
			loadContracts() {
				let _this = this;
				_this.loading = true;
				_this.filterContracts = [];
				axios.get("/admin/companycontracts/"+_this.filterItems.company_id+"/search").then((res) => {
					res.data.map((rowContract) => {
						_this.filterContracts.push({
							id: rowContract.contract_id,
							corporate_name: rowContract.contracts.corporate_name
						});
					});
					_this.filterContracts.sort(function(a, b){
						return a.corporate_name - b.corporate_name;
					});
					_this.loading = false;
				}).catch((err) => {
					_this.loading = false;
				});
			},
      loadSectors(source) {
				let _this = this;
				_this.loading = true;

				if(source == 'filter'){

					_this.filterSectors = [];
					_this.modalSectors = [];
					_this.gridSectors = [];

					axios.get("/admin/sectors/"+_this.filterItems.sublocal_id+"/search").then((res) => {
						res.data.sort(function(a, b){
							return a.name - b.name;
						});
						_this.filterSectors = _this.filterSectors.concat(res.data);
						_this.modalSectors = _this.modalSectors.concat(res.data);
						_this.gridSectors = _this.gridSectors.concat(res.data);
						_this.loading = false;
					}).catch((err) => {
						_this.loading = false;
				});

				}

			},
			loadSubsectors(source) {
				let _this = this;
				_this.loading = true;

				if(source == 'filter'){

					_this.filterSubsectors = [];
					_this.modalSubsectors = [];
					_this.gridSubsectors = [];
				
					axios.get("/admin/subsectors/"+_this.filterItems.sublocal_id+"/search").then((res) => {
						res.data.sort(function(a, b){
							return a.name - b.name;
						});
						_this.filterSubsectors = _this.filterSubsectors.concat(res.data);
						_this.modalSubsectors = _this.modalSubsectors.concat(res.data);
						_this.gridSubsectors = _this.gridSubsectors.concat(res.data);
						_this.loading = false;
					}).catch((err) => {
						_this.loading = false;
					});

				}

			},
			clearFilter(){
				this.filterItems = {
					company_id: 3,
					work_place_id: 3,
					sublocal_id: null,
					itemsSelected: null,
					sector_id: null,
					subsector_id: null,
					start_date: null,
					end_date: null,
					movement_id: null
				};
        this.loadActivities();
			},
			validateCompany(source){
				let _this = this;
				_this.loading = true;

				if(source == 'filter'){

					_this.filterWorkplaces = [];
					axios.get("/admin/companyworkplaces/"+_this.filterItems.company_id+'/search').then((res) => {
						res.data.map((rowReturn) => {
							_this.filterWorkplaces = _this.filterWorkplaces.concat(rowReturn.work_places);
						});
						_this.filterWorkplaces.sort(function(a, b){
							return a.corporate_name - b.corporate_name;
						});
						_this.loadContracts();
					}).catch((err) => {
					});
					this.loading = false;

				}
			},
			validateWorkplace(source){
				let _this = this;

				if(source == 'filter'){

					_this.filterSublocal = [];
					axios.get("/admin/workplacesublocal/"+_this.filterItems.work_place_id+"/search").then((res) => {
						res.data.map((rowSublocal) => {
							_this.filterSublocal.push({
								corporate_name: rowSublocal.sublocal.corporate_name,
								id: rowSublocal.sublocal_id
							});
						});
						_this.loading = false;
					}).catch((err) => {
						_this.loading = false;
					});

				}

			},
			validateSublocal(source){
				let _this = this;

				_this.loadSectors(source);
				_this.loadSubsectors(source);

			},
      validateStatus(items, type){
        if(items.length == 0){
          return '';
        }else{
          var text = 'text-success';

          items.map((rowItem) => {
            //2 = Ativa
            //6 = Concluída
            //9 - Concluída (atraso)
            if(rowItem.activity_status_id == 2 || rowItem.activity_status_id == 5 || rowItem.activity_status_id == 7 || rowItem.activity_status_id == 8){
              if(type == 'occurrences'){
								text = 'text-warning';
							}else{
								text = 'text-danger';
							}
            }
          })
          return text;
        }
      },
			viewActivities(item){
	
				this.selectedModal = {
					showing: [],
					total: [],
					activities: [],
					occurrences: []
				};

				this.selectedModal.active = 'all';

				this.selectedModal.showing = item.activities;
				this.selectedModal.showing.push(...item.occurrences);
				this.selectedModal.total = item.activities;
				this.selectedModal.total.push(...item.occurrences);
				this.selectedModal.activities = item.activities;
				this.selectedModal.occurrences = item.occurrences;

				$('#modalActivities').modal('show');
			},
			filterActivities(type){
				this.selectedModal.showing = [];
				if(type == 'all'){
					this.selectedModal.showing = this.selectedModal.total;
				}else if(type == 'activities'){
					this.selectedModal.showing = this.selectedModal.activities;
				}else if(type == 'occurrences'){
					this.selectedModal.showing = this.selectedModal.occurrences;
				}
				this.selectedModal.active = type;
			},
			goToActivity(item){
				if(item.occurrence_id != null){
					location.href = '/admin/occurrences/'+item.occurrence_id;
				}else{	
					location.href = '/admin/activities/'+item.id;
				}
			}
		}
	}
</script>
<style>
	.custom-tabs {
		display: flex;
		background-color: #fff;
		border-radius: 999px;
		box-shadow: 0 4px 12px rgba(0,0,0,0.05);
		padding: 5px;
		overflow: hidden;
		width: fit-content;
		margin: auto;
	}

	.custom-tab {
		border: none;
		background: transparent;
		color: #000;
		padding: 10px 20px;
		border-radius: 999px;
		font-weight: 500;
		transition: all 0.3s;
		position: relative;
	}

	.custom-tab.active {
		background-color: #e0eaff;
		color: #ff6e24;
		font-weight: 600;
	}

	.custom-tab .badge {
		background-color: #ff6e24;
		color: #fff;
		font-size: 0.75rem;
		border-radius: 999px;
		padding: 4px 8px;
		margin-left: 8px;
	}

	.table-container {
		max-width: 800px;
		margin: 2rem auto;
    }

	.item-activity:hover .card{
		cursor: pointer;
		box-shadow: #9e9e9e 0px 0px 5px;
		transition: all 0.3s ease;
	}
</style>